export enum LoanField {
    Issuer = 'issuers',
    Industry = 'industries',
    Facility = 'facilities',
    UseOfProceeds = 'useOfProceeds',
    RefIndex = 'refIndexes',
    Arranger = 'arrangers',
    CoArranger = 'coArrangers',
    DraftArranger = 'draftArrangers',
    DraftCoArranger = 'draftCoArrangers',
    PassingReasons = 'passingReasons',
}
